import { AMC_DEVICE_PAGE_URL, DEVICE_DETAIL_PAGE, STATUS_TRACKING_URL } from '@/configs/constants';
import { AMC_TAG_COLOR_MAP, COHORT_STATUS, INSTALLATION_REQUEST } from '@/constants/amc';
import { IR_WORK_ORDER_QUERY } from '@/constants/app';
import Tag from '@/shared/crisp/Tag';
import Div from '@/shared/Div';
import Image from '@/shared/Image';
import Paragraph from '@/shared/Paragraph';
import classNames from 'classnames';
import React from 'react';
import Repair from '../Icons/Repair';
import { useProductContext } from '@/context/productContext';
import LinkButton from '@/shared/LinkButton';
import { getURLWithQueryParams } from '@/utils/urls';

type AssetDetailCardProps = {
  assetId?: string;
  isIR?: boolean;
  ticketnumber?: string;
  productName?: string;
  productImage?: string;
  address?: string;
  cohortStatus?: string;
  woStatus?: string;
  workOrderDetails?: any;
  selectedAssetData?: any;
};
function AssetDetailCard({
  assetId,
  isIR = false,
  ticketnumber,
  productName,
  productImage,
  address,
  cohortStatus,
  woStatus,
  workOrderDetails,
  selectedAssetData,
}: AssetDetailCardProps) {
  const { state: product, dispatch } = useProductContext();

  const redirectTo = isIR
    ? getURLWithQueryParams(STATUS_TRACKING_URL, {
        reqId: ticketnumber,
        [IR_WORK_ORDER_QUERY]: true,
      })
    : `${DEVICE_DETAIL_PAGE}/${assetId}`;

  const handleCardClick = () => {
    if (!isIR) {
      if (workOrderDetails) {
        dispatch.setWODetails(workOrderDetails);
      }
      dispatch.setProductsData(selectedAssetData);
    }
  };
  return (
    <LinkButton href={redirectTo} onClick={handleCardClick}>
      <Div
        className={classNames(
          'flex flex-col  pt-s5 gap-s3 rounded-cs border border-co-subtle max-w-sm md:max-w-lg',
          {
            'pb-s4': !woStatus,
          },
        )}
      >
        <Div className="flex gap-s3 pr-s4 pl-s3 ">
          <Image
            loading="eager"
            priority={true}
            src={productImage ?? ''}
            height={72}
            width={72}
            alt={productName}
            className="object-contain h-full aspect-square"
            data-testid="device-image"
          />
          <Div className="flex flex-col gap-s3 w-full flex-1 min-w-0">
            <Div className="flex flex-col  min-w-0 ">
              <Paragraph className="text-cti-primary text-button-normal">{productName}</Paragraph>
              <Paragraph className="text-cti-tertiary truncate">{address}</Paragraph>
            </Div>
            {cohortStatus ? (
              <Tag className={classNames('w-fit', AMC_TAG_COLOR_MAP[cohortStatus], {})}>
                {COHORT_STATUS?.[cohortStatus]}
              </Tag>
            ) : null}
          </Div>
        </Div>
        {woStatus ? (
          <Div
            className={classNames(
              'px-s4 py-s3 w-full flex gap-s3 justify-center items-center rounded-bl-cs rounded-br-cs',
              {
                'bg-orange-100 text-extended-decorativeOrangeBold':
                  woStatus === INSTALLATION_REQUEST,
                ' bg-extended-decorativeBlueSubtle text-extended-efbrand':
                  woStatus !== INSTALLATION_REQUEST,
              },
            )}
          >
            <Repair colorFill={isIR ? '#FF8400' : '#003594'} />
            <Paragraph className="text-body-sm font-bold">{woStatus}</Paragraph>
          </Div>
        ) : null}
      </Div>
    </LinkButton>
  );
}

export default AssetDetailCard;
